module.exports = __webpack_public_path__ + "static/media/dodgem(6).26ef8086.PNG";